module.exports = __webpack_public_path__ + "img/ico-whatsapp.c39d45c4.png";